import axios from "axios";
import { TActivityLog } from "../types/activityLog";
import { toCamelCase } from "../utils/objectHelper";
import qs from "qs";

export const ActivityLogTransports = {
    listAll: async (params: any): Promise<TActivityLog[]> => {
        const { data } = await axios.get<any[]>(
            `/activityLog${params ? `?${qs.stringify(params)}` : ""}`
        );
        return data.map((current: any) => toCamelCase(current));
    },
    totalRows: async (params: any): Promise<number> => {
        const { data } = await axios.get<number>(
            `/activityLog/totalRows${params ? `?${qs.stringify(params)}` : ""}`
        );
        return data;
    },
    totalFiltered: async (params: any): Promise<number> => {
        const { data } = await axios.get<number>(
            `/activityLog/totalFiltered${params ? `?${qs.stringify(params)}` : ""}`
        );
        return data;
    },
    listUser: async (): Promise<TActivityLog[]> => {
        const { data } = await axios.get<any[]>(`/activityLog/userLog`);
        return data.map((current: any) => toCamelCase(current));
    },
};
